import { createAsyncThunk } from "@reduxjs/toolkit";
import { FetchErrorLogs } from "../api/ErrorLogApi";

export const FetchErrorLogAsync = createAsyncThunk(
  "error_log/backend",
  async ({ path }, { rejectWithValue }) => {
    try {
      const response = await FetchErrorLogs(path);
      return response.data.data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
